// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import DataProducts from './DataProducts'
import PathDatabase from './PathDatabase'
import ProjectTracker from './ProjectTracker'
import Protection from './Protection'

const CTAButtons = () => (
  <main className={'home-cta-row'}>
    <ProjectTracker />
    <Protection />
    <PathDatabase />
    <DataProducts />
  </main>
)

export default CTAButtons
